import thunk from 'redux-thunk'
import { createStore, applyMiddleware, compose } from 'redux'
import RootReducer from './reducers/RootReducer'

const initialState = {}
const middlewares = [thunk]
let devtools = (x) => x

if (
    process.env.NODE_ENV !== 'production' &&
    process.browser &&
    window.__REDUX_DEVTOOLS_EXTENSION__
) {
    devtools = window.__REDUX_DEVTOOLS_EXTENSION__()
}

export const Store = createStore(
    RootReducer,
    initialState,
    compose(applyMiddleware(...middlewares), devtools)
)

export const saveState = (state) => {
    try {
        const serialisedState = JSON.stringify(state);
        const date = new Date().getUTCDate();
        localStorage.setItem('state', serialisedState);
        localStorage.setItem('lastSeen', date);
        localStorage.setItem('i18nextLng', state.i18n.currentLocale);
    } catch (err) {
        console.log(err);
    }
};
